import PropTypes from 'prop-types';

export default PropTypes.shape({
  description: PropTypes.string,
  showEyebrow: PropTypes.bool,
  showTimestamp: PropTypes.bool,
  title: PropTypes.string,
});
